import Layout from "@/layout";

const carNetworkingManageRouter = {
  path: "/carNetworkingManage",
  component: Layout,
  redirect: "/carNetworkingManage",
  name: "carNetworkingManage",
  meta: {
    title: "车联网管理"
  },
  children: [
    {
      path: "personnelManagement",
      component: () =>
        import("@/views/carNetworkingManage/personnelManagement/index.vue"),
      name: "personnelManagement",
      meta: { title: "人员管理", icon: "" },
      alwaysShow: true
    },
    {
      path: "vehicleManagement",
      component: () =>
        import("@/views/carNetworkingManage/vehicleManagement/index.vue"),
      name: "vehicleManagement",
      meta: { title: "车辆管理", icon: "" },
      alwaysShow: true
    }
  ]
};

export default carNetworkingManageRouter;
